import { toast } from "sonner";
import { X_URL, TELEGRAM_URL } from "../config";
import Reveal, { SectionHead } from "./Reveal";

export default function Community() {
    return (
        <section id="community" data-testid="community-section" className="relative scroll-mt-24 py-24 lg:py-32">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_50%_at_50%_50%,rgba(168,85,247,0.08),transparent)]" />
            <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6">
                <SectionHead kicker="COMMUNITY" title="JOIN THE BALD ARMY" />
                <Reveal delay={0.1}>
                    <p className="mx-auto mt-6 max-w-xl text-base md:text-lg text-slate-400">
                        Every bald pigeon starts somewhere.
                        <br />
                        <span className="font-bold text-white">Follow. Share. Make memes. Bring your friends.</span>
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
                        <a
                            href={X_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="community-follow-x-button"
                            className="btn-primary w-full sm:w-auto"
                        >
                            FOLLOW ON X
                        </a>
                        {TELEGRAM_URL ? (
                            <a
                                href={TELEGRAM_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="community-telegram-button"
                                className="btn-outline-purple w-full sm:w-auto"
                            >
                                JOIN TELEGRAM
                            </a>
                        ) : (
                            <button
                                type="button"
                                data-testid="community-telegram-button"
                                onClick={() => toast("Telegram coming soon. Stay bald. 🕊️")}
                                className="btn-outline-purple w-full sm:w-auto"
                            >
                                JOIN TELEGRAM
                            </button>
                        )}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
